import { RandomGenerator } from "../test-utils";
var UserSiteDataBuilder = /** @class */ (function () {
    function UserSiteDataBuilder() {
        this.userSiteData = {
            id: RandomGenerator.randomString(),
            displayName: RandomGenerator.randomString(),
            domain: RandomGenerator.randomString(),
            isPublished: RandomGenerator.randomBoolean(),
            isPremium: RandomGenerator.randomBoolean(),
        };
    }
    UserSiteDataBuilder.prototype.withId = function (id) {
        this.userSiteData.id = id;
        return this;
    };
    UserSiteDataBuilder.prototype.withDisplayName = function (displayName) {
        this.userSiteData.displayName = displayName;
        return this;
    };
    UserSiteDataBuilder.prototype.withDomain = function (domain) {
        this.userSiteData.domain = domain;
        return this;
    };
    UserSiteDataBuilder.prototype.withIsPublished = function (isPublished) {
        this.userSiteData.isPublished = isPublished;
        return this;
    };
    UserSiteDataBuilder.prototype.withIsPremium = function (isPremium) {
        this.userSiteData.isPremium = isPremium;
        return this;
    };
    UserSiteDataBuilder.prototype.build = function () {
        return this.userSiteData;
    };
    return UserSiteDataBuilder;
}());
export { UserSiteDataBuilder };
//# sourceMappingURL=user-site-data-builder.js.map